module.exports = __webpack_public_path__ + "img/risk_img_certificate@3x.39ed7d2a.png";